<template lang="pug">
el-collapse-item(name='enlacePersona')
    template(slot='title')
        h2.collapse-titulo {{ $t('mensagens.territorio.territorioAr.persona.titulo') }}

    .collapse-conteudo
        EnlacePersona(
            @update='onUpdate'
            @delete='onDelete'
            :papeis='papeis'
            :representantes='representantes'
            :options='options'
            :loading='loading'
            :mostrar-titulo='false'
        )
</template>

<script>
import EnlacePersona from '@/components/territorio/EnlacePersona.vue';

export default {
    name: 'EnlacePersonaCollapse',
    components: {
        EnlacePersona
    },
    props: {
        papeis: {
            type: Array,
            default: () => []
        },
        representantes: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        },
        loading: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    methods: {
        onUpdate(value) {
            this.$emit('update', value);
        },
        onDelete(index) {
            this.$emit('delete', index);
        }
    }
};
</script>

<style lang="scss" scoped>
.collapse-titulo {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-left: 20px;
    color: #3b3b3b;
}

.collapse-conteudo {
    padding: 16px;
}
</style>
